var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0024 9.00022V13.0002M12.0024 17.0002H12.0124M21.7324 18.0002L13.7324 4.00022C13.5579 3.69243 13.305 3.43641 12.9993 3.25829C12.6936 3.08017 12.3462 2.98633 11.9924 2.98633C11.6386 2.98633 11.2911 3.08017 10.9854 3.25829C10.6798 3.43641 10.4268 3.69243 10.2524 4.00022L2.25237 18.0002C2.07605 18.3056 1.9836 18.6521 1.98438 19.0047C1.98516 19.3573 2.07915 19.7035 2.25682 20.008C2.43449 20.3126 2.68952 20.5648 2.99607 20.7391C3.30261 20.9133 3.64978 21.0034 4.00237 21.0002H20.0024C20.3533 20.9999 20.6979 20.9072 21.0017 20.7315C21.3054 20.5558 21.5576 20.3033 21.7329 19.9993C21.9082 19.6954 22.0004 19.3506 22.0003 18.9997C22.0002 18.6488 21.9078 18.3041 21.7324 18.0002Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleAlert);
export default __webpack_public_path__ + "res/media/triangle-alert.c6291828812b6e0007a4b8ecdc2680fe.svg";
export { ForwardRef as ReactComponent };